<template>
  <img style="cursor: pointer; margin-bottom: 3px" src="../assets/back.png" @click="back" />
  <img style="float: right;cursor: pointer;" src="../assets/exportPDF.png" @click="generateReport" />

  <div>
    <Vue3Html2pdf :show-layout="false" :float-layout="true" :enable-download="true" :preview-modal="false"
      :paginate-elements-by-height="4000" :filename="fileNameScheda" :pdf-quality="2" :manual-pagination="false"
      pdf-format="a4" pdf-orientation="portrait" pdf-content-width="760px" ref="schedaAlimentoPrint">
      <template v-slot:pdf-content>
        <div style="display: flex; ">
          <div style="width:50%;margin-left: 1em;">
            <img src="../assets/logo-BDA.gif" />
          </div>
          <div style="width:50%;margin-left: 6em;padding-top: 1em;">
            <img src="../assets/logo-IEO.gif" />
          </div>
        </div>
        <FoodInfo :id="id" :lang="language"></FoodInfo>        
        <FoodDetailComponent :id="id" :lang="language" @error="onError" :portion="portionValue"></FoodDetailComponent>
      </template>
    </Vue3Html2pdf>
  </div>

  <div>
    <FoodInfo :id="id" :lang="language"></FoodInfo>
  </div>

  <div class="centerElement">
    <FoodPortion @select-portion="onSelectPortion" :lang="language" :portion="portionstandard" :portiondes="portionDescription"></FoodPortion>
  </div>

  <div>
    <FoodDetailComponent :id="id" :lang="language" :portion="portionValue" @error="onError"></FoodDetailComponent>
  </div>
</template>

<script>
import api from "../js/apiConsts.js";
import apiConsts from "../js/apiConsts.js";
import { axiosPost } from "../js/apiService.js";
import FoodDetailComponent from "@/components/FoodDetailComponent.vue";
import FoodInfo from "@/components/FoodInfoComponent.vue";
import FoodPortion from "./FoodPortion.vue";
import Vue3Html2pdf from 'vue3-html2pdf'
export default {
  name: "FoodComponent",
  emits: { back: null, error: null },
  props: ["id", "language"],
  components: {
    FoodDetailComponent,
    FoodInfo,
    FoodPortion,
    Vue3Html2pdf
  },
  data() {
    return {
      fileNameScheda: "Scheda alimento",
      lang: this.language.toLowerCase().trim() == apiConsts.DEFLANG ? 0 : 1,
      portionValue: 100,
      portionstandard: 100,
      portionDescription: "Porzione Standard",
      portiondespdf: "",
      foodInfoData: null,
      ispdfpage: true
    }
  },
  async mounted() {
    await this.loadFoodInfo();
  },
  methods: {
    async loadFoodInfo() {
      await axiosPost(api.APIFoodInfo, {
        language: this.lang,
        foodId: this.id,
      })
        .then((response) => {
          let res = response.data;
          this.foodInfoData = null;
          if (res.success) {
            this.foodInfoData = res.foodInfo;
            this.portionstandard = this.foodInfoData.portionValue;
            this.portionDescription = this.foodInfoData.portionDescription;
          } else {
            this.$emit('error', res.message);
          }
        })
        .catch((err) => {
          this.$emit('error', err.message);
        });
    },
    back() {
      this.$emit("back");
    },
    generateReport() {
      this.portiondespdf = "Valore per " + this.portionValue + " g ";
      this.$refs.schedaAlimentoPrint.generatePdf()
    },
    onSelectPortion(value) {
      this.portionValue = value;
    },
    onError(message) {
      this.$emit('error', message);
    }
  },
};
</script>

<style></style>